import React, { useEffect, useState } from 'react';
import Banner from '../components/Banner';
import Ozellikler from '../components/Ozellikler';
import Solutions from '../components/Solutions';
import IoPlatform from '../components/FeatureShowcase';
import { getHomeData } from '../services/api';

const Home = () => {
    const [homeData, setHomeData] = useState(null);

    useEffect(() => {
        getHomeData().then((data) => {
            setHomeData(data);
        });
    }, []);

    const sections = homeData?.pageContent || [];

    const heroSection = sections.find(
        (s) => s.__component === 'sections.hero'
    );

    const featuresSection = sections.find(
        (s) => s.__component === 'sections.features-section'
    );

    const moduleSection = sections.find(
        (s) => s.__component === 'sections.module-section'
    );

    const showcaseSection = sections.find(
        (s) => s.__component === 'sections.feature-showcase'
    );

    return (
        <>
            <Banner data={heroSection} />
            <IoPlatform data={showcaseSection} />
            <Ozellikler data={featuresSection} />
            <Solutions data={moduleSection} />
        </>
    );
};

export default Home;